export enum ParcoursPath {
  DOMAINE = 'Parcours',
  DOCUMENTS = 'documents',
  DOCUMENT_OLD = 'documents_old',
  ROOT = '',
  EDITION = 'edition-parcours',
  EDITION_GENERAL = 'general',
  EDITION_SESSION = 'sessions',
  CONTRATS = 'contrats',
  LISTE_INSCRIPTIONS = 'inscriptions-parcours',
  ID_PARCOURS_PARAM = 'IdParcours',
  TARIFS = 'tarifs',
  CREATION_INSCRIPTION = 'creation-inscription',
  CREATION_MULTI_INSCRIPTION = 'creation-multi-inscription',
  EDITION_INSCRIPTION = 'edition-inscription',
  FACTURES = 'factures',
  EDITION_BROUILLON_FACTURE = 'edition-brouillon',
  VISUALISE_FACTURE = 'visualise-facture',
  RESUME_PARCOURS = 'resume-parcours',
  CREATION_CONTRAT = 'creation-contrat',
  EDITION_CONTRAT = 'edition-contrat',
  CREATION_SEANCE = 'creation-seance',
  EDITION_SEANCE = 'edition-seance',
  LISTE_SEANCES = 'seances',
  CREATION = 'creation',
  CREATION_COMPOSE = 'creation-compose'
}
